import React, { memo, Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import "./style.css";

const VerticalNav = memo(() => {
  const location = useLocation();
  const adminType = localStorage.getItem("adminType");

  const icons = {
    dashboard: "ri-dashboard-line",
    admins: "ri-user-settings-line",
    etsy: "ri-store-2-line",
    products: "ri-box-3-line",
    listings: "ri-list-check-2",
    pricing: "ri-money-dollar-circle-line",
    diamond: "ri-diamond-line",
    gold: "ri-coins-line",
    logout: "ri-logout-box-line",
    logsIcon: "ri-list-check-2",
  };

  const menuItems = [
    {
      section: "MAIN",
      items: [
        {
          path: "/dashboard",
          name: "Dashboard",
          icon: icons.dashboard,
        },
      ],
    },

    {
      section: "USERS",
      items: [
        {
          path: "/dashboard/admin-list",
          name: "Admins",
          icon: icons.admins,
        },
      ],
    },

    {
      section: "ETSY INTEGRATION",
      items: [
        {
          path: "/etsy/list",
          name: "Connected Etsy Shops",
          icon: icons.etsy,
        },
        {
          path: "/listing/list",
          name: "Listing Management",
          icon: icons.listings,
        },
        {
          path: "/product/list",
          name: "Product List",
          icon: icons.products,
        },
      ],
    },

    {
      section: "PRICING",
      items: [
        {
          path: "/settings",
          name: "Pricing Settings",
          icon: icons.pricing,
        },
        {
          path: "/diamond-rates",
          name: "Diamond Rates",
          icon: icons.diamond,
        },
        {
          path: "/gold-rates",
          name: "Gold Rates",
          icon: icons.gold,
        },
        {
          path: "/logs",
          name: "Logs",
          icon: icons.logsIcon,
        },
      ],
    },

    {
      section: "SYSTEM",
      items: [
        {
          path: "/auth/logout",
          name: "Logout",
          icon: icons.logout,
        },
      ],
    },
  ];

  // Filter based on admin type
  const filteredMenu = menuItems.map((group) => {
    let items = group.items;

    if (adminType === "Sales") {
      items = items.filter((item) => item.name !== "Admins");
    }

    if (adminType === "SUB") {
      items = items.filter((item) => item.name !== "Admins");
    }

    return { ...group, items };
  });

  return (
    <Fragment>
      <Accordion as="ul" className="navbar-nav iq-main-menu">
        {filteredMenu.map((group, i) => (
          <Fragment key={i}>
            {/* Section Title */}
            <li className="nav-section-title px-1 mt-2 mb-1 mx-2 text-black small fw-bold">
              {group.section}
            </li>

            {/* Section Items */}
            {group.items.map((item, index) => (
              <li
                key={index}
                className={`p-0 nav-item ${
                  location.pathname === item.path ? "active" : ""
                }`}
              >
                <Link
                  to={item.path}
                  className={`nav-link ${
                    location.pathname === item.path ? "active" : ""
                  }`}
                >
                  <i className={`${item.icon}`} style={{ fontSize: 16 }}></i>
                  <span className="item-name m-0" style={{ fontSize: 14 }}>
                    {item.name}
                  </span>
                </Link>
              </li>
            ))}
          </Fragment>
        ))}

        <li>
          <hr className="hr-horizontal" />
        </li>
      </Accordion>
    </Fragment>
  );
});

export default VerticalNav;
